export default (() => {

    const global = {
        elements: {},
        pageData: {}
    };

    function initialise (config) {
        _cacheDom();
        _cacheModelData(config);
        _bindEvents();
        _setUpResendSmsButton();
    }

    function _cacheDom () {
        // Inputs
        global.elements.pin = document.querySelector('[data-pin-input]');

        // Buttons
        global.elements.submit = document.querySelector('[data-submit-button]');
        global.elements.resendSms = document.querySelector('[data-resend-sms]');
        global.elements.resendSmsLiveRegion = document.querySelector('[data-resend-sms-live-region]');
    }

    function _cacheModelData (config) {
        for (const key in config) {
            global.pageData[key] = config[key];
        }
    }

    function _bindEvents () {
        const pinField = global.elements.pin;

        pinField.addEventListener(pinField.events.ValueChange.name, _removeServerError);
    }

    function _removeServerError () {
        const hasServerError = global.elements.pin[wealthify.FieldValidation.messagePropEnums.Custom] !== '';

        if(hasServerError){
            global.elements.pin[wealthify.FieldValidation.messagePropEnums.Custom] = '';
            global.elements.pin.validation.events.ResetValidation.dispatch();
        }
    }

    function _setUpResendSmsButton () {
        if (!global.pageData.isSms) {
            return;
        }

        if (_hasSmsResendTimerElapsed()) {
            _enableResend();
            
            return;
        }

        const timer = setInterval(() => {
            if (_hasSmsResendTimerElapsed()) {
                _enableResend();
                clearInterval(timer);
            }
        }, 1000);
    }

    function _enableResend () {
        global.elements.resendSms.disabledProp = false;
        global.elements.resendSmsLiveRegion.textContent = 'SMS resend button re-enabled.';
    }

    function _hasSmsResendTimerElapsed () {
        const secondsSinceSmsSent = (Date.now() - global.pageData.smsLastSentDateTime) / 1000;

        return secondsSinceSmsSent > global.pageData.smsResendTimeoutSeconds;
    }

    return { initialise };
})();